import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid';

export interface ActionsCellRendererParams {
  onOpenHistory: (data: any) => void;
}

/**
 * Actions Cell Renderer for Summary Material Grid
 *
 * Displays an action button to open history modal
 */
@Component({
  selector: 'app-actions-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <button
      mat-icon-button
      matTooltip="Acciones"
      (click)="onHistoryClick($event)">
      <mat-icon>open_in_new</mat-icon>
    </button>
  `,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
  `]
})
export class ActionsCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get customParams(): ActionsCellRendererParams | undefined {
    return this.params?.colDef?.cellRendererParams as ActionsCellRendererParams;
  }

  onHistoryClick(event: Event): void {
    event.stopPropagation();
    if (this.customParams?.onOpenHistory && this.params?.data) {
      this.customParams.onOpenHistory(this.params.data);
    }
  }
}
